/* file description */

import type { UseOptionProp } from './type';

export const useOptionProp: UseOptionProp = ({ options }) => {
  return (
    options ?? {
      fullScreen: false,
      reload: true,
      setting: true,
    }
  );
};
